// @ts-nocheck


import React from 'react';
import styled from 'styled-components';

import Input from 'antd/lib/input';
import Button from 'antd/lib/button';


import Form from '../../../components/Form';

import { Section } from '../../../components/layout';
import Grid, { GridItem } from '../../../components/layout/Grid';
import CancelButton from './../../../components/CancelButton';
import Selects from './../../../components/selects';

const { MaintenanceTypeOfWorkSelect } = Selects;

const StyledSection = styled(Section).withConfig({ displayName: "InnerForm__StyledSection", componentId: "sc-1ivlnky-0" })(["padding:16px;"]);


const Footer = styled(Section).withConfig({ displayName: "InnerForm__Footer", componentId: "sc-1ivlnky-1" })(["padding:16px;display:flex;justify-content:space-between;"]);











export default ({ maintenanceWorkType, onCancel, onSubmit }) =>
<Form initialValues={maintenanceWorkType} onSubmit={onSubmit}>
    {(
  FormField,
  {
    setFieldValue,
    handleSubmit,
    handleBlur,
    values,
    dirty,
    isSubmitting
  }) =>

  <form onSubmit={handleSubmit}>
        <StyledSection>
          <Grid gutter="16px">
            <GridItem>
              <FormField label="Наименование" fast name="name" required>
                {(field) => <Input {...field} />}
              </FormField>
            </GridItem>
            <GridItem>
              <FormField label="Тип работ" fast name="workType" required>
                {({ name, value }) =>
            <MaintenanceTypeOfWorkSelect
              value={value}
              onChange={(type) => {
                setFieldValue(name, type);
              }} />

            }
              </FormField>
            </GridItem>
          </Grid>
        </StyledSection>
        <Footer>
          <Button
        disabled={isSubmitting}
        loading={isSubmitting}
        type="primary"
        htmlType="submit">

            {values.id ? 'Сохранить' : 'Создать'}
          </Button>
          <CancelButton dirty={dirty} onClick={onCancel}>
            Отменить
          </CancelButton>
        </Footer>
      </form>
  }
  </Form>;
